import { Link } from 'react-router-dom'
import profileImg from '../images/profile.jpeg'

export default function SideBar() {
    return (
        <div id="sidebar" className="d-flex flex-column text-light">
            <a href="/"><img id="profile-img" src={profileImg} alt="Profile"></img></a>

            <h3>Diego Miranda</h3>
            <p className="sidebar-item">
                Data Scientist / ML Engineer
            </p>

            <div className="sidebar-item">
                <i className="bi bi-person-square"></i>
                &nbsp;<a href="/">Resume</a>
            </div>
            <div className="sidebar-item">
                <i className="bi bi-envelope"></i>
                &nbsp;<a href="mailto:diegommir@gmail.com">diegommir@gmail.com</a>
            </div>
            <div className="sidebar-item">
                <i className="bi bi-linkedin"></i>
                &nbsp;<a href="https://www.linkedin.com/in/diegommir/" target="linkedin">linkedin.com/in/diegommir</a>
            </div>
            <div className="sidebar-item">
                <i className="bi bi-github"></i>
                &nbsp;<a href="https://github.com/diegommir/" target="github">github.com/diegommir</a>
            </div>

            {/* <h3>Portifolio</h3>
            <div className="sidebar-item">
                <i className="bi bi-file-bar-graph"></i>
                &nbsp;<Link to="/portifolio/google-fiber-case-study">Google Fiber Case Study</Link>
            </div>
            <div className="sidebar-item">
                <i className="bi bi-file-bar-graph"></i>
                &nbsp;<Link to="/jupyter/bellabeat-case-study">Bellabeat Case Study</Link>
            </div>
            <div className="sidebar-item">
                <i className="bi bi-file-bar-graph"></i>
                &nbsp;<Link to="/portifolio/dashboard-excel">Responsive Dashboard with Excel</Link>
            </div>
            <div className="sidebar-item">
                <i className="bi bi-file-bar-graph"></i>
                &nbsp;<Link to="/jupyter/titanic">Titanic Competition</Link>
            </div> */}
        </div>
    )
}
